<template>
  <section class="">
    <ul class="divide-y">
      <a
        v-for="(note, index) in notes"
        :key="index"
        class="flex flex-col p-4 md:flex-row hover:bg-default-200"
        :href="note.links.url"
      >
        <h6 class="font-semibold">{{note.title}}</h6>
      </a>
    </ul>
  </section>
</template>

<script>
import Semed from "./../../api/Semed";
import Paginate from "./../global/Paginate.vue";

export default {
  name: "indexNote",
  props: ["path"],
  components: { Paginate },

  data() {
    return {
      notes: null,
      loading: true,
    };
  },
  created() {
    Semed.get(this.path).then((response) => {
      this.notes = response.data;
    });
  },
  methods: {
    getNotes(link) {
      this.loading = true;
      Api.get(link).then((response) => {
        this.notes = response;
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped></style>
